import api from '@/api'
import i18n from '@/i18n'

const mutation = {
  countries: 'SET_COUNTRIES',
  residences: 'SET_RESIDENCES',
  cities: 'SET_CITIES',
  units: 'SET_UNITS',
  types: 'SET_TYPES',
  classes: 'SET_CLASSES',
  taxes: 'SET_TAXES',
  notes: 'SET_NOTES',
  reasons: 'SET_REASONS',
  ivatypes: 'SET_IVA_TYPES',
  billformats: 'SET_FORMATS',
  paymenttypes: 'SET_PAYMENTS',
  expedients: 'SET_EXPEDIENTS',
  downloadfileformats: 'SET_DFF',
  pdfFileFormats: 'SET_PDF_FORMATS',
  fileTypes: 'SET_FILE_TYPES_OPT',
  rectifiedReasons: 'SET_RECTIFIED_REASONS',
  events: 'SET_EVENTS',
  statusOptionsasProvider: 'SET_STATUS_OPTIONS',
  statusOptionsasPayer: 'SET_STATUS_OPTIONS',
  statusOptionsfactoring: 'SET_STATUS_OPTIONS',
  statusOptionsfinanceables: 'SET_STATUS_OPTIONS',
  statusOptionsthirdParty: 'SET_STATUS_OPTIONS',
  statusOptionsdrafts: 'SET_STATUS_OPTIONS',
  statusOptionsautoInvoices: 'SET_STATUS_OPTIONS',
  statusOptionsthirdPartyDrafts: 'SET_STATUS_OPTIONS',
  paymentMethodType: 'SET_PAYMENT_METHOD_TYPE',
  documentNature: 'SET_DOCUMENT_NATURE',
  representationType: 'SET_REPRESENTATION_TYPE',
  documentType: 'SET_DOCUMENT_TYPE',
  referenceT: 'SET_REFERENCES_T'
}

/* TODO: improve fetch selectors to enqueue then and only request once */

export const fetchSelector = ({ commit, state, dispatch }, selector) => {
  return new Promise((resolve, reject) => {
    try {
      if (Object.keys(state[selector]).length > 0 || state.queue.some(s => s === selector)) {
        resolve()
        return
      }
      state.queue.push(selector)
      let webLocale = i18n.locale
      api.apiSferest.get(`selectors/${selector}/${webLocale}`, { data: {} }).then((res) => {
        if (!Array.isArray(res.data)) reject(new Error(`${res} must be an array`))
        if (!mutation[selector]) reject(new Error(`There is no mutation defined for ${selector}`))
        commit(mutation[selector], res.data)
        state.queue = state.queue.filter(s => s === selector)
        dispatch('loaded')
        resolve(res.data)
      })
    } catch (err) {
      console.log(err)
      reject(new Error(`selector '${selector}', ${err}`))
    }
  })
}

export const fetchStatus = ({ commit, state, dispatch }, type) => {
  return new Promise((resolve, reject) => {
    let selector = `statusOptions${type}`
    let webLocale = i18n.locale
    try {
      api.apiSferest.get(`selectors/${selector}/${webLocale}`, { data: {} }).then((res) => {
        if (!Array.isArray(res.data)) reject(new Error(`${res} must be an array`))
        if (!mutation[selector]) reject(new Error(`There is no mutation defined for ${selector}`))
        commit(mutation[selector], res.data)
        state.queue = state.queue.filter(s => s === selector)
        dispatch('loaded')
        resolve(res.data)
      })
    } catch (err) {
      console.error(err)
      reject(new Error(`selector '${selector}', ${err}`))
    }
  })
}

export const loading = ({ commit }) => {
  return new Promise((resolve) => {
    commit('SET_LOADED', false)
    resolve(false)
  })
}

export const loaded = ({ commit }) => {
  return new Promise((resolve) => {
    commit('SET_LOADED', true)
    resolve(true)
  })
}
